import type { RouteRecordRaw } from 'vue-router'

const requirementRoutes: RouteRecordRaw[] = [
  {
    path: 'requirements',
    component: () => import('@/views/requirement/RequirementLayout.vue'),
    meta: { permission: 'requirement:record:view' },
    children: [
      {
        path: '',
        name: 'requirements',
        component: () => import('@/views/requirement/RequirementList.vue'),
        meta: { permission: 'requirement:record:view' }
      },
      {
        path: ':id',
        name: 'requirement-detail',
        component: () => import('@/views/requirement/RequirementDetail.vue'),
        meta: { permission: 'requirement:record:view' }
      }
    ]
  }
]

export default requirementRoutes
